import { Place } from './place';
import { Plan } from './plan';
import { User } from './user';

export enum JoinFeedUserType {
  RESIDENT = 'RESIDENT',
  PAST_TRAVELER = 'PAST_TRAVELER',
  CURRENT_TRAVELER = 'CURRENT_TRAVELER',
}

export type JoinFeedUser = User & {
  joinFeedType: JoinFeedUserType;
  travelInfo?: {
    startDate: Date;
    endDate: Date;
    planId: string;
  };
};

export type JoinFeedItem = {
  location: Place;
  users: JoinFeedUser[];
  plans: Plan[];
};
